import { render, staticRenderFns } from "./CoordinationPlanTab.vue?vue&type=template&id=3e57724a&scoped=true"
import script from "./CoordinationPlanTab.vue?vue&type=script&lang=js"
export * from "./CoordinationPlanTab.vue?vue&type=script&lang=js"
import style0 from "./CoordinationPlanTab.vue?vue&type=style&index=0&id=3e57724a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e57724a",
  null
  
)

export default component.exports